module.exports = __webpack_public_path__ + "img/error.f47c4da7.png";